import { Roles } from '../types';

export const OPERATOR_HIERARCHY = [Roles.OPERATOR];
export const SITE_SUPERVISOR_HIERARCHY = [...OPERATOR_HIERARCHY, Roles.SITE_SUPERVISOR];
export const SITE_ADMIN_HIERARCHY = [...SITE_SUPERVISOR_HIERARCHY, Roles.SITE_ADMIN];
export const ACCOUNT_ADMIN_HIERARCHY = [...SITE_ADMIN_HIERARCHY, Roles.ACCOUNT_ADMIN];
export const LEVIANT_ADMIN_HIERARCHY = [...ACCOUNT_ADMIN_HIERARCHY, Roles.LEVIANT_ADMIN];
